import React from 'react';
import Tooltip from 'components/Tooltip';

const SourceButton = ({backgroundColor, icon, onSelect, name, disabled}) => {
    return (
        <>
            <Tooltip placement="bottom" tooltip={disabled ? `Only one ${name} source can be active at a time` : `Add ${name} source`}>
                <div onClick={() => onSelect()}
                     className={`filter-icon add-entity-source-btn ${disabled ? 'disabled-filter' : ''} ${name === 'Instagram' ?
                      'filter-icon--instagram' : ''}`}
                     style={{fontSize: '22px', backgroundColor}}
                >
                    <i className="fas fa-plus hidden-plus"/>
                    <i className={`${icon} other-icon`}/>
                </div>
            </Tooltip>
        </>
    );
};

export default SourceButton;
